<template>
    <div class="modal-user-info" @click="onClose">
        <div class="user-info-modal-box" @click.stop="">
            <div class="user-info-header-box">
                <div class="user-info-title-box">
                    {{ $t("common.Change_picture") }}
                </div>
            </div>
            <div class="user-info-body">
                <div class="user-head-list-bg">
                    <div class="user-head-list-bg-item"></div>
                    <div class="user-head-list-bg-item"></div>
                    <div class="user-head-list-bg-item"></div>
                </div>
                <div class="user-head-list">
                    <template v-for="(item, index) in list">
                        <div
                            class="user-head-item"
                            :key="index"
                            @click="onClickItem(item)"
                        >
                            <div
                                class="user-head-bigbg ico ico-head-bg-big"
                            ></div>
                            <div
                                class="user-head-bigbg-s ico ico-head-bg-select"
                                v-if="item.id == selectid"
                            ></div>
                            <div
                                class="ico"
                                :class="'ico-avatar-' + item.id"
                                :style="'z-index:10;'"
                            ></div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import userfun from "../../utils/userFun";
import ServerManager from "../../interface/server";
import tools from "../../utils/fun";
import eventConfig from "../../baseConfig/eventConfig";
export default {
    name: "Modal",
    props: {},
    data() {
        return {
            list: [],
            selectid: 1,
        };
    },
    mounted() {
        //userfun.getHeadIdByUrl("http://slots-static.bangbet.com/avatar_1.jpg");
        this.selectid = userfun.getHeadIdByUrl(
            this.$store.state.user.realUser.avatar
        );
        for (let i = 0; i < 10; i++) {
            this.list.push({ id: i + 1, url: i + 1 });
        }
    },
    methods: {
        onClickItem(item) {
            console.log(item);
            this.selectid = item.id;
            console.log(userfun.getHeadUrlById(item.id));
            this.changeName();
        },
        changeName() {
            tools.setLoadingState(true);
            ServerManager.updateUser(
                this,
                "avatar",
                userfun.getHeadUrlById(this.selectid),
                (data) => {
                    tools.setLoadingState(false);
                    console.log(data);

                    if (data.result == 1) {
                        this.getUserAction();
                       
                    }
                },
                (error) => {
                    tools.setLoadingState(false);
                }
            );
        },
        getUserAction() {
            tools.setLoadingState(true);
            ServerManager.getUserInfo(
                this,
                (data) => {
                    tools.setLoadingState(false);
                },
                (error) => {
                    tools.setLoadingState(false);
                }
            );
        },
        onClose() {
            tools.emit(eventConfig.playEffect, "pop");
            this.$emit("on-close");
        },
        onOK() {
            this.$emit("on-ok");
        },
    },
};
</script>
<style>
@import "../../assets/css/user.css";
.user-info-body {
    margin-top: 18px;
    height: 659px;
    width: 580px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
}
.user-head-list-bg {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
}
.user-head-list-bg-item {
    margin-top: 29px;
    width: 524px;
    height: 121px;
    background: #2a2a2b;
    opacity: 0.8;
    border-radius: 61px;
}
.user-head-list {
    position: absolute;
    top: 0px;
    left: 28px;
    width: 524px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
}
.user-head-bigbg {
    position: absolute;
}
.user-head-bigbg-s {
    position: absolute;
}
.user-head-item {
    position: relative;
    margin-left: 20px;
    margin-top: 24px;
    width: 105px;
    height: 128px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/user/rummy_change_head.vue